import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PropietarioService } from "../../../../shared/services/propietarios.service";
import {
  ColaboradoresService,
  ColaboradorPayload,
} from "../../../../shared/services/colaboradores.service";
import { VehiculoFrecuenteService } from "../../../../shared/services/vehiculo-frecuente.service";
import { MedioTransporteService } from "../../../../shared/services/medio-transporte.service";
import { RolViaService } from "../../../../shared/services/rol-via.service";
import { Utils } from "../../../../shared/utils/Utils";

import { catchError, map } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
import { CapacitacionProgramacionService } from "../../../../shared/services/capacitaciones_programacion.service";
import { CapacitacionAsistenciaView, CapacitacionesAsistentesService } from "../../../../shared/services/capacitacion_asistentes.service";
import { SiniestrosService } from "../../../../shared/services/siniestrosViales.service";
import { InfraccionService } from "../../../../shared/services/infracciones.service";
const Swal = require("sweetalert2");

@Component({
  selector: "app-colaboradores-pesv",
  templateUrl: "./colaboradores.component.html",
  styleUrls: ["./colaboradores.component.scss"],
})
export class ColaboradoresPesvComponent implements OnInit {
  cargando = false;
  guardandoLote = false;
  colaboradores: any[] = [];
  colaboradoresFiltrados: any[] = [];
  filtro = "";
  pageSize = 10;
  page = 1;
  sortColumn = "";
  sortDirection: "asc" | "desc" = "asc";
  formularioPorCedula: Record<string, any> = {};
  colaboradorModalSeleccionado: any = null;
  capacitacionesProgramacion: any[] = [];
  CapacitacionAsistenciaView: CapacitacionAsistenciaView[] = [];
  participantes: any[] = [];
  opcionesSiNo = [
    { value: 1, label: "SI" },
    { value: 0, label: "NO" },
  ];

  opcionesRolVial: Array<{ value: number; label: string }> = [];

  opcionesMedioTransporte: Array<{ value: number; label: string }> = [];

  opcionesVehiculo: Array<{ value: number; label: string }> = [];

  opcionesEstadoPago = [
    { value: 1, label: "PENDIENTE" },
    { value: 2, label: "ACUERDO DE PAGO" },
    { value: 3, label: "PAZ Y SALVO" },
  ];

  opcionesTipoRegistro = [
    { value: 1, label: "SIMPLE" },
    { value: 2, label: "COMPLEJA" },
  ];
  siniestros!: any[];
  banderaSiniestros: boolean = false;
  infracciones: any[] = [];



  constructor(
    private propietarioService: PropietarioService,
    private colaboradoresService: ColaboradoresService,
    private vehiculoFrecuenteService: VehiculoFrecuenteService,
    private medioTransporteService: MedioTransporteService,
    private rolViaService: RolViaService,
    private modalService: NgbModal,
    private CapacitacionesAsistentesService: CapacitacionesAsistentesService,
    private capacitacionProgramacionService: CapacitacionProgramacionService,
    private SiniestrosService: SiniestrosService,
    private infraccionService: InfraccionService
  ) {}

  ngOnInit(): void {
    this.cargarOpcionesRolVia();
    this.cargarOpcionesMedioTransporte();
    this.cargarOpcionesVehiculoFrecuente();
    this.cargarColaboradores();
  }

  private valorRolViaPorDefecto(): number {
    return this.opcionesRolVial.length ? this.opcionesRolVial[0].value : 1;
  }

  private sincronizarRolViaPorDefectoEnFormulario(): void {
    if (!this.opcionesRolVial.length) {
      return;
    }

    const valoresPermitidos = new Set(this.opcionesRolVial.map((opcion) => Number(opcion.value)));
    const valorPorDefecto = this.valorRolViaPorDefecto();

    Object.keys(this.formularioPorCedula).forEach((cedula) => {
      const fila = this.formularioPorCedula[cedula];
      if (!fila) {
        return;
      }

      const valorActual = Number(fila.rol_desplazamiento);
      if (!valoresPermitidos.has(valorActual)) {
        fila.rol_desplazamiento = valorPorDefecto;
      }
    });
  }

  private cargarOpcionesRolVia(): void {
    this.rolViaService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.rolvia)
          ? respuesta.rolvia
          : Array.isArray(respuesta?.rolesVia)
          ? respuesta.rolesVia
          : [];

        const activos = lista.filter((item: any) => Number(item?.Estado ?? item?.estado ?? 1) === 1);
        this.opcionesRolVial = activos.map((item: any) => ({
          value: Number(item.idRolVia ?? item.id),
          label: String(item.descripcionRolVia || item.descripcion || "Sin descripcion"),
        }));

        if (!this.opcionesRolVial.length) {
          this.opcionesRolVial = [...this.opcionesSiNo];
        }

        this.sincronizarRolViaPorDefectoEnFormulario();
      },
      error: () => {
        this.opcionesRolVial = [...this.opcionesSiNo];

        this.sincronizarRolViaPorDefectoEnFormulario();
      },
    });
  }

  private valorMedioTransportePorDefecto(): number {
    return this.opcionesMedioTransporte.length ? this.opcionesMedioTransporte[0].value : 1;
  }

  private valorVehiculoPorDefecto(): number {
    return this.opcionesVehiculo.length ? this.opcionesVehiculo[0].value : 1;
  }

  private cargarOpcionesVehiculoFrecuente(): void {
    this.vehiculoFrecuenteService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.vehiculosFrecuentes)
          ? respuesta.vehiculosFrecuentes
          : [];

        const activos = lista.filter((item: any) => Number(item?.estado ?? 1) === 1);
        this.opcionesVehiculo = activos.map((item: any) => ({
          value: Number(item.id),
          label: String(item.descripcion || "Sin descripcion"),
        }));

        if (!this.opcionesVehiculo.length) {
          this.opcionesVehiculo = [{ value: 1, label: "Sin datos" }];
        }

         Object.keys(this.formularioPorCedula).forEach((cedula) => {
          const fila = this.formularioPorCedula[cedula];
          if (!fila || !fila.vehiculo_frecuente) {
            fila.vehiculo_frecuente = this.valorVehiculoPorDefecto();
          }
        }); 
      },
      error: () => {
        this.opcionesVehiculo = [
          { value: 1, label: "Moto" },
          { value: 2, label: "Carro" },
          { value: 3, label: "Camioneta" },
          { value: 4, label: "Bus" },
          { value: 5, label: "Ninguno" },
        ];
      },
    });
  }

  private cargarOpcionesMedioTransporte(): void {
    this.medioTransporteService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta)
          ? respuesta
          : Array.isArray(respuesta?.mediosTransporte)
          ? respuesta.mediosTransporte
          : [];

        const activos = lista.filter((item: any) => Number(item?.estado ?? 1) === 1);
        this.opcionesMedioTransporte = activos.map((item: any) => ({
          value: Number(item.id),
          label: String(item.descripcion || "Sin descripcion"),
        }));

        if (!this.opcionesMedioTransporte.length) {
          this.opcionesMedioTransporte = [{ value: 1, label: "Sin datos" }];
        }

         Object.keys(this.formularioPorCedula).forEach((cedula) => {
          const fila = this.formularioPorCedula[cedula];
          if (!fila || !fila.medio_transporte) {
            fila.medio_transporte = this.valorMedioTransportePorDefecto();
          }
        }); 
      },
      error: () => {
        this.opcionesMedioTransporte = [
          { value: 1, label: "Moto" },
          { value: 2, label: "Carro" },
          { value: 3, label: "Bicicleta" },
          { value: 4, label: "Transporte publico" },
          { value: 5, label: "A pie" },
        ];
      },
    });
  }

  cargarColaboradores(): void {
    this.cargando = true;
    forkJoin({
      propietarios: this.propietarioService.getPropietarios(),
      colaboradoresPesv: this.colaboradoresService
        .getAllColaboradores()
        .pipe(catchError(() => of([]))),
    }).subscribe({
      next: ({ propietarios, colaboradoresPesv }) => {
        this.colaboradores = Array.isArray(propietarios?.propietarios)
          ? propietarios.propietarios
          : [];
        this.inicializarFormularioPorCedula(colaboradoresPesv);
        this.aplicarFiltro();
        //this.cargarDatosPorCedula();
        this.cargando = false;
      },
      error: (error) => {
        console.error("Error al cargar colaboradores PESV:", error);
        this.cargando = false;
      },
    });
  }

  private inicializarFormularioPorCedula(colaboradoresPesv: any): void {
    const registros = Array.isArray(colaboradoresPesv)
      ? colaboradoresPesv
      : Array.isArray(colaboradoresPesv?.colaboradores)
      ? colaboradoresPesv.colaboradores
      : [];

    const indexPorCedula: Record<string, any> = {};
    registros.forEach((registro: any) => {
      const key = String(registro?.cedula || "");
      if (key) {
        indexPorCedula[key] = registro;
      }
    });

    const nuevoFormulario: Record<string, any> = {};
    this.colaboradores.forEach((persona) => {
      const cedula = String(persona?.cedula || "");
      if (!cedula) {
        return;
      }

      const encontrado = indexPorCedula[cedula];
      nuevoFormulario[cedula] = {
        id: encontrado?.id || null,
        cedula: Number(cedula),
        capacitacion: Number(encontrado?.capacitacion ?? 1),
        evaluacion_competencia: Number(encontrado?.evaluacion_competencia ?? 1),
        sufrio_siniestros: Number(encontrado?.sufrio_siniestros ?? 0),
        numero_paz: encontrado?.numero_paz || null,
        fecha_ultima_revision: encontrado?.fecha_ultima_revision || null,
        tipo: Number(encontrado?.tipo ?? 1),
        estado_pago: Number(encontrado?.estado_pago ?? 1),
        medio_transporte: Number(
          encontrado?.medio_transporte ?? this.valorMedioTransportePorDefecto()
        ),
        rol_desplazamiento: Number(encontrado?.rol_desplazamiento ?? this.valorRolViaPorDefecto()),
        vehiculo_frecuente: Number(
          encontrado?.vehiculo_frecuente ?? this.valorVehiculoPorDefecto()
        ),
        estado: Number(encontrado?.estado ?? 1),
        seleccionado: true,
        guardando: false,
      };
    });

    this.formularioPorCedula = nuevoFormulario;
  }

  private normalizarRespuestaCedula(respuesta: any): any[] {
    if (Array.isArray(respuesta)) {
      return respuesta;
    }

    if (Array.isArray(respuesta?.colaboradores)) {
      return respuesta.colaboradores;
    }

    if (respuesta && typeof respuesta === "object") {
      return [respuesta];
    }

    return [];
  }

  private aplicarRegistroEnFila(cedula: string, registro: any): void {
    const fila = this.obtenerRegistroFila({ cedula });
    if (!fila || !registro) {
      return;
    }

    fila.id = registro?.id || fila.id || null;
    fila.capacitacion = Number(registro?.capacitacion ?? fila.capacitacion ?? 1);
    fila.evaluacion_competencia = Number(
      registro?.evaluacion_competencia ?? fila.evaluacion_competencia ?? 1
    );
    fila.sufrio_siniestros = Number(
      registro?.sufrio_siniestros ?? fila.sufrio_siniestros ?? 0
    );
    fila.numero_paz = registro?.numero_paz ?? fila.numero_paz ?? null;
    fila.fecha_ultima_revision =
      registro?.fecha_ultima_revision ?? fila.fecha_ultima_revision ?? null;
    fila.tipo = Number(registro?.tipo ?? fila.tipo ?? 1);
    fila.estado_pago = Number(registro?.estado_pago ?? fila.estado_pago ?? 1);
    fila.medio_transporte = Number(
      registro?.medio_transporte ?? fila.medio_transporte ?? this.valorMedioTransportePorDefecto()
    );
    fila.rol_desplazamiento = Number(
      registro?.rol_desplazamiento ?? fila.rol_desplazamiento ?? this.valorRolViaPorDefecto()
    );
    fila.vehiculo_frecuente = Number(
      registro?.vehiculo_frecuente ?? fila.vehiculo_frecuente ?? 1
    );
    fila.estado = Number(registro?.estado ?? fila.estado ?? 1);
  }

  private cargarDatosPorCedula(): void {
    const cedulas = this.colaboradores
      .map((persona) => String(persona?.cedula || "").trim())
      .filter((cedula) => !!cedula);

    if (!cedulas.length) {
      return;
    }

    const consultas = cedulas.map((cedula) =>
      this.colaboradoresService.getColaboradoresByCedula(cedula).pipe(
        map((respuesta) => ({
          cedula,
          registros: this.normalizarRespuestaCedula(respuesta),
        })),
        catchError(() => of({ cedula, registros: [] }))
      )
    );

    forkJoin(consultas).subscribe((resultados: any[]) => {
      resultados.forEach((item) => {
        const registro = item?.registros?.length ? item.registros[0] : null;
        if (registro) {
          this.aplicarRegistroEnFila(item.cedula, registro);
        }
      });
    });
  }

  obtenerRegistroFila(persona: any): any {
    const key = String(persona?.cedula || "");
    if (!key) {
      return null;
    }

    if (!this.formularioPorCedula[key]) {
      this.formularioPorCedula[key] = {
        id: null,
        cedula: Number(key),
        capacitacion: 1,
        evaluacion_competencia: 1,
        sufrio_siniestros: 0,
        numero_paz: null,
        fecha_ultima_revision: null,
        tipo: 1,
        estado_pago: 1,
        medio_transporte: this.valorMedioTransportePorDefecto(),
        rol_desplazamiento: this.valorRolViaPorDefecto(),
        vehiculo_frecuente: this.valorVehiculoPorDefecto(),
        estado: 1,
        seleccionado: true,
        guardando: false,
      };
    }

    return this.formularioPorCedula[key];
  }

  actualizarCampoFila(persona: any, campo: string, valor: any): void {
    const registro = this.obtenerRegistroFila(persona);
    if (!registro) {
      return;
    }

    registro[campo] = Number(valor);
  }

  actualizarCampoFilaTexto(persona: any, campo: string, valor: any): void {
    const registro = this.obtenerRegistroFila(persona);
    if (!registro) {
      return;
    }

    registro[campo] = valor || null;
  }

  abrirModalFormularioColaborador(content: any, persona: any): void {
    console.log("Abrir modal para persona:", persona);
    const registro = this.obtenerRegistroFila(persona);
    if (!registro) {
      Swal.fire("Advertencia", "No se pudo identificar el registro del colaborador.", "warning");
      return;
    }

    this.colaboradorModalSeleccionado = persona;
    
    //console.log("Registro del colaborador seleccionado:", registro);

    this.CapacitacionesAsistentesService
  .getCapacitacionAsistenciaByCedula(persona.cedula)
  .subscribe({
    next: (data: CapacitacionAsistenciaView[]) => {
      this.participantes = data;
      // Aquí recibes el arreglo de asistencias
    },
    error: (err) => {
      console.error('Error al obtener asistencias:', err);
    },
    complete: () => {
      console.log('Consulta finalizada');
    }
  });
    //console.log(persona.cedula);
    this.SiniestrosService.getConductoresSiniestrosByCedula(persona.cedula).subscribe({
      next: (data: any[]) => {
        this.siniestros = data;
     //   console.log('Siniestros obtenidos:', this.siniestros.length);
        if (this.siniestros.length > 0) {
         this.banderaSiniestros = true;
        }
      },
      error: (err) => {
        console.error('Error al obtener siniestros:', err);
      },
      /* complete: () => {
        console.log('Consulta de siniestros finalizada');
        this.modalService.open(content, {
          size: "xl",
          centered: true,
          backdrop: "static",
        });
      } */
    });

    this.infraccionService.getInfraccionesByDocumento(persona.cedula).subscribe({
      next: (data: any[]) => {
        this.infracciones = data;
        console.log('Infracciones obtenidas:', this.infracciones.length);
        
      },
       error: (err) => {
        console.error('Error al obtener infracciones:', err);
      },
      complete: () => {
        console.log('Consulta de infracciones finalizada');
        this.modalService.open(content, {
          size: "xl",
          centered: true,
          backdrop: "static",
        });
      }
    });
  }

  guardarFormularioModal(modal: any): void {
    if (!this.colaboradorModalSeleccionado) {
      Swal.fire("Advertencia", "No hay colaborador seleccionado.", "warning");
      return;
    }

    this.guardarFilaColaborador(this.colaboradorModalSeleccionado, () => modal.close());
  }

  guardarFilaColaborador(persona: any, onFinish?: () => void): void {
    const registro = this.obtenerRegistroFila(persona);
    if (!registro) {
      return;
    }

    const fechaActual = new Date().toISOString();
    const payload: ColaboradorPayload = {
      cedula: Number(registro.cedula),
      capacitacion: Number(registro.capacitacion),
      evaluacion_competencia: Number(registro.evaluacion_competencia),
      sufrio_siniestros: this.banderaSiniestros ? 1 : 0,
      numero_paz: registro.numero_paz || null,
      fecha_ultima_revision: registro.fecha_ultima_revision || null,
      tipo: Number(registro.tipo),
      estado_pago: Number(registro.estado_pago),
      medio_transporte: Number(registro.medio_transporte),
      rol_desplazamiento: Number(registro.rol_desplazamiento),
      vehiculo_frecuente: Number(registro.vehiculo_frecuente),
      estado: Number(registro.estado),
      fecha_creacion: fechaActual,
      fecha_modificacion: fechaActual,
    };

    const esActualizacion = Boolean(registro.id);
    registro.guardando = true;
    const request$ = esActualizacion
      ? this.colaboradoresService.updateColaborador(registro.id, {
          ...payload,
          fecha_modificacion: fechaActual,
        })
      : this.colaboradoresService.createColaborador(payload);

    request$.subscribe({
      next: (resp: any) => {
        registro.guardando = false;
        if (!registro.id) {
          const possibleId = resp?.id || resp?.colaborador?.id || null;
          if (possibleId) {
            registro.id = Number(possibleId);
          }
        }
        Swal.fire("Exito", esActualizacion ? "Registro actualizado." : "Registro guardado.", "success");
        onFinish?.();
      },
      error: (error) => {
        registro.guardando = false;
        Swal.fire("Error", error?.error?.message || "Error al guardar", "error");
        onFinish?.();
      },
    });
  }

  guardarSeleccionados(): void {
    const personasSeleccionadas = this.colaboradoresFiltrados.filter((persona) => {
      const registro = this.obtenerRegistroFila(persona);
      return registro?.seleccionado;
    });

    if (!personasSeleccionadas.length) {
      Swal.fire("Advertencia", "Selecciona al menos una persona para guardar.", "warning");
      return;
    }

    this.guardandoLote = true;

    const fechaActual = new Date().toISOString();
    const requests = personasSeleccionadas.map((persona) => {
      const registro = this.obtenerRegistroFila(persona);
      if (!registro) {
        return of({ ok: false });
      }

      registro.guardando = true;

      const payload: ColaboradorPayload = {
        cedula: Number(registro.cedula),
        capacitacion: Number(registro.capacitacion),
        evaluacion_competencia: Number(registro.evaluacion_competencia),
        sufrio_siniestros: Number(registro.sufrio_siniestros),
        tipo: Number(registro.tipo),
        estado_pago: Number(registro.estado_pago),
        medio_transporte: Number(registro.medio_transporte),
        numero_paz: registro.numero_paz || null,
        fecha_ultima_revision: registro.fecha_ultima_revision || null,
        rol_desplazamiento: Number(registro.rol_desplazamiento),
        vehiculo_frecuente: Number(registro.vehiculo_frecuente),
        estado: Number(registro.estado),
        fecha_creacion: fechaActual,
        fecha_modificacion: fechaActual,
      };

      const id = Number(registro.id || 0);
      const req$ = id
        ? this.colaboradoresService.updateColaborador(id, {
            ...payload,
            fecha_modificacion: fechaActual,
          })
        : this.colaboradoresService.createColaborador(payload);

      return req$.pipe(
        map((resp: any) => ({ ok: true, resp, id, registro })),
        catchError((error) => {
          console.error("Error guardando colaborador PESV:", error);
          return of({ ok: false, id, registro });
        })
      );
    });

    forkJoin(requests).subscribe((resultados: any[]) => {
      let guardados = 0;

      resultados.forEach((item) => {
        const registro = item?.registro;
        if (registro) {
          registro.guardando = false;
        }

        if (!item?.ok) {
          return;
        }

        if (registro && !registro.id) {
          const possibleId = item?.resp?.id || item?.resp?.colaborador?.id || null;
          if (possibleId) {
            registro.id = Number(possibleId);
          }
        }
        guardados += 1;
      });

      this.guardandoLote = false;
      if (guardados === personasSeleccionadas.length) {
        Swal.fire("Exito", `Se guardaron ${guardados} registros.`, "success");
      } else if (guardados > 0) {
        Swal.fire(
          "Advertencia",
          `Se guardaron ${guardados} de ${personasSeleccionadas.length} registros.`,
          "warning"
        );
      } else {
        Swal.fire("Error", "No se pudo guardar ningun registro.", "error");
      }
    });
  }

  aplicarFiltro(): void {
    const termino = (this.filtro || "").trim().toLowerCase();
    this.page = 1;

    const filtrados = !termino
      ? [...this.colaboradores]
      : this.colaboradores.filter((persona) => {
      const nombreCompleto = [
        persona?.primernombre,
        persona?.segundonombre,
        persona?.papellidos,
        persona?.seapellidos,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return (
        String(persona?.cedula || "").toLowerCase().includes(termino) ||
        nombreCompleto.includes(termino) ||
        String(persona?.mail || "").toLowerCase().includes(termino) ||
        String(persona?.telcel || "").toLowerCase().includes(termino) ||
        String(persona?.cargoData?.cargos || "").toLowerCase().includes(termino) ||
        String(persona?.condicionLaboral?.label || "").toLowerCase().includes(termino)
      );
    });

    this.colaboradoresFiltrados = filtrados;
    if (this.sortColumn) {
      this.sortData(this.sortColumn, true);
    }
  }

  nombreCompleto(persona: any): string {
    return [persona?.primernombre, persona?.segundonombre, persona?.papellidos, persona?.seapellidos]
      .filter(Boolean)
      .join(" ");
  }

  sortData(column: string, preserveDirection = false): void {
    if (this.sortColumn === column && !preserveDirection) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else if (this.sortColumn !== column) {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    const listToSort = this.colaboradoresFiltrados.length ? this.colaboradoresFiltrados : this.colaboradores;
    const direction = this.sortDirection === "asc" ? 1 : -1;

    listToSort.sort((a, b) => {
      let aVal: any;
      let bVal: any;

      if (column === "nombreCompleto") {
        aVal = this.nombreCompleto(a).toLowerCase();
        bVal = this.nombreCompleto(b).toLowerCase();
      } else {
        aVal = this.getNestedValue(a, column);
        bVal = this.getNestedValue(b, column);

        if (typeof aVal === "string") {
          aVal = aVal.toLowerCase();
        }

        if (typeof bVal === "string") {
          bVal = bVal.toLowerCase();
        }
      }

      if (aVal < bVal) {
        return -1 * direction;
      }

      if (aVal > bVal) {
        return 1 * direction;
      }

      return 0;
    });

    this.colaboradoresFiltrados = [...listToSort];
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj) ?? "";
  }

  formatearFechaNacimiento(fecha: any): string {
    if (!fecha) {
      return "-";
    }

    const fechaTexto = String(fecha).trim();
    if (!fechaTexto) {
      return "-";
    }

    // Formato yyyy-mm-dd o yyyy/mm/dd
    const isoMatch = fechaTexto.match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})/);
    if (isoMatch) {
      const [, yyyy, mm, dd] = isoMatch;
      return `${dd}/${mm}/${yyyy}`;
    }

    // Formato dd-mm-yyyy o dd/mm/yyyy
    const latamMatch = fechaTexto.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})/);
    if (latamMatch) {
      const [, dd, mm, yyyy] = latamMatch;
      return `${dd}/${mm}/${yyyy}`;
    }

    const parsed = new Date(fechaTexto);
    if (!Number.isNaN(parsed.getTime())) {
      const dd = String(parsed.getDate()).padStart(2, "0");
      const mm = String(parsed.getMonth() + 1).padStart(2, "0");
      const yyyy = parsed.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    }

    return "-";
  }

  private obtenerPrimeraInscripcion(persona: any): any | null {
    const inscripciones = persona?.InscripcionesData;
    if (Array.isArray(inscripciones)) {
      return inscripciones.length ? inscripciones[0] : null;
    }

    return inscripciones || null;
  }

  obtenerNombreCapacitacion(persona: any): string {
    const inscripcion = this.obtenerPrimeraInscripcion(persona);
    return inscripcion?.capacitacion?.nombre || "-";
  }

  obtenerTemaCapacitacion(persona: any): string {
    const inscripcion = this.obtenerPrimeraInscripcion(persona);
    return inscripcion?.capacitacion?.tema || "-";
  }

  obtenerTituloAcademias(persona: any): string {
    const academias = persona?.academias;

    if (Array.isArray(academias)) {
      const titulos = academias
        .map((academia: any) => {
          const titulo = academia?.titulo;
          const nivel = academia?.nivel?.nombre;

          if (!titulo && !nivel) {
            return null;
          }

          return nivel ? `${titulo || "-"} (${nivel})` : titulo;
        })
        .filter((titulo: any) => Boolean(titulo));

      return titulos.length ? titulos.join(", ") : "-";
    }

    if (academias && typeof academias === "object") {
      return academias?.nivel?.nombre
        ? `${academias?.titulo || "-"} (${academias?.nivel?.nombre})`
        : academias?.titulo || "-";
    }

    return "-";
  }

  sinMultasRegistradas(): boolean {
    return !this.infracciones?.length;
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
}
